export const layout = {
  index: '/',
  kakaochannel: 'http://pf.kakao.com/_LZRdE',
  blog: 'https://blog.naver.com/jebs_jemm',
  youtube: 'https://www.youtube.com/@JEBS.official',
  instagram: 'https://www.instagram.com/jebs.official/',
};
